export default "__VITE_ASSET__78128b4b__"